module.exports = __webpack_public_path__ + "static/img/db4_pc.809b55ba.jpg";